// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1d7fa793","175":"71817629","535":"2e101db0","708":"8f0a0b19","728":"95275dff","787":"d18cb1f0"}[chunkId] + ".chunk.js";
};